<div
  class="kr-exchange__header"
  data-testid="exchange_crypto_fiat_header"
  [style.display]="!isPageOpened ? 'none' : null">
  <h4
    class="kr-exchange__header-text"
    data-testid="exchange_crypto_fiat_header_title">
    {{ 'exchange.dialog.title' | translate }}
  </h4>

  <button
    class="kr-exchange__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    data-testid="exchange_crypto_fiat_close_button"
    (click)="dialogRef.close()">
    <fu-icon
      iconName="close-square"
      data-testid="exchange_crypto_fiat_close_icon"></fu-icon>
  </button>
</div>

<div
  class="kr-exchange__body"
  data-testid="exchange_crypto_fiat_body"
  [style.padding]="!isPageOpened ? '0!important' : null">
  <div class="kr-exchange__content" data-testid="exchange_crypto_fiat_content">
    <fu-icon
      iconName="failed"
      size="64"
      data-testid="exchange_crypto_fiat_failed_icon" />

    <h5
      class="kr-failed-message"
      translate="exchange.dialog.failed.title"
      data-testid="exchange_crypto_fiat_failed_title"></h5>

    <div
      class="kr-details kr-details_center"
      data-testid="exchange_crypto_fiat_failed_details">
      <label
        class="kr-details__label"
        translate="exchange.dialog.failed.message"
        data-testid="exchange_crypto_fiat_failed_message_label">
      </label>

      <span
        class="kr-details__value kr-details_danger"
        data-testid="exchange_crypto_fiat_failed_error">
        {{ store.exchangeError()?.originalError.error.error_description }}
      </span>
    </div>
  </div>
</div>
